import { render, staticRenderFns } from "./ChargebeeUpsellTag.vue?vue&type=template&id=5753771c&scoped=true&"
import script from "./ChargebeeUpsellTag.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellTag.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellTag.vue?vue&type=style&index=0&id=5753771c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753771c",
  null
  
)

export default component.exports